/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { BalanceIcon } from '../assets/svg/StatusIcon';
import { useSelector } from 'react-redux';
const CookieBanner: React.FC = () => {
  const [isBannerVisible, setIsBannerVisible] = useState(false);

  useEffect(() => {
    const hasVisited = getCookie('userVisited');
    if (!hasVisited) {
      setIsBannerVisible(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('userVisited', 'true', 365);
    setIsBannerVisible(false);
  };

  const setCookie = (name: string, value: string, days: number) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/;secure;SameSite=Strict`;
  };

  const getCookie = (name: string) => {
    const nameEQ = name + '=';
    const cookiesArray = document.cookie.split(';');
    for (let i = 0; i < cookiesArray.length; i++) {
      let c = cookiesArray[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries } = contentfulData;
  const signInContentfulldata = entries?.rb_signin;

  if (!isBannerVisible) return null;
  return (
    <div
      role="region"
      aria-label="Cookie consent banner"
      className="fixed bottom-0 w-full bg-light-blue p-4 flex flex-col bg-banner-bg min-h-[170px] px-10 py-5 gap-2"
    >
      <div className="flex gap-2 items-center">
        <div aria-label="balanceIcon">
          <BalanceIcon fill="#003D46" />
        </div>
        <h2
          className="text-text16 font-semibold text-Text-Clr-Feedback-info"
          aria-label={signInContentfulldata?.cookieTitle}
        >
          {signInContentfulldata?.cookieTitle}
        </h2>
      </div>
      <div className="flex items-start justify-between flex-col xl:flex-row gap-5">
        <p
          className="text-[16px] text-black ml-[22px] font-medium w-full xl:w-[70%]"
          aria-label={signInContentfulldata?.cookieContentTextOne}
        >
          {signInContentfulldata?.cookieContentTextOne}{' '}
          <a
           href={entries?.rb_links?.rbLinksCollection?.privacy_policy}
            className="text-primary-red hover:underline"
            aria-label={signInContentfulldata?.cookieContentTextTwo}
             target="_blank"
              rel="noopener noreferrer"
          >
            {signInContentfulldata?.cookieContentTextTwo}
          </a>
        </p>

        <button
          className="ml-[22px] xl:ml-0 min-h-[48px] w-[156px] bg-primary-red hover:bg-red-700 text-white font-medium py-2 px-4 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 border border-1 border-primary-red"
          aria-label={signInContentfulldata?.cookieCtaTitle}
          onClick={handleClose}
        >
          {signInContentfulldata?.cookieCtaTitle}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
